import { useState } from 'react';
import {
  Button,
  Chip,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  Grid,
  IconButton,
  Typography,
} from '@material-ui/core';
import { FilterList as MFilter } from '@material-ui/icons/';
import ArrowDownward from '@material-ui/icons/ArrowDownward';
import HighlightOff from '@material-ui/icons/HighlightOff';
import ArrowUpward from '@material-ui/icons/ArrowUpward';
import CreateIcon from '@material-ui/icons/Create';
import Height from '@material-ui/icons/Height';
import Refresh from '@material-ui/icons/Refresh';

import { RadioGroup } from '../../core/controls';
import { truncateSpan, withTooltip } from '../../core/format';
import { darkBlue, orange } from '../../core/theme';
import {
  VisitSearchFieldCriteria,
  VisitSearchApi,
  visitSearchApi,
} from '../../core/visit-search-api';
import React from 'react';
import { createPageApi, validDateObject } from '../../core';

function Filter(props: VisitSearchFieldCriteria) {
  const { icon, editable, form, valueLabel, label, api, field } = props;
  const { deleteFilter, openFilter } = api.actions;

  const onDelete = () => {
    deleteFilter(props);
  };

  const onEdit = () => {
    openFilter(props);
  };

  const { values } = form.values((s) => s.value);
  const name = field?.fieldName || 'filter';

  return (
    <Chip
      size="small"
      color="primary"
      label={
        <Grid
          container
          direction="row"
          spacing={1}
          justify="space-around"
          alignItems="center"
          style={{ flexWrap: 'nowrap' }}
        >
          <Grid item style={{ paddingLeft: 11, paddingBottom: 5 }}>
            <Typography
              id={name + '-sort'}
              style={{
                whiteSpace: 'nowrap',
                fontWeight: 'bold',
                color: 'white',
              }}
              variant="caption"
              color="textSecondary"
            >
              {label}
            </Typography>
          </Grid>

          <Grid item style={{ paddingBottom: 5 }}>
            <Typography
              color="textSecondary"
              variant="caption"
              style={{ whiteSpace: 'nowrap', color: 'white' }}
            >
              {truncateSpan(
                valueLabel ? valueLabel(props) : (values || '').toString(),
                '90px',
                false
              )}
            </Typography>
          </Grid>
          {editable ? (
            <Grid item>
              <IconButton
                onClick={onEdit}
                style={{ width: '8px', height: '8px' }}
                id={"edit-filtter-" + name ? name?.toLowerCase()?.trim() : '' + "-btn"}
              >
                <CreateIcon fontSize="small" htmlColor="white" />
              </IconButton>
            </Grid>
          ) : null}
        </Grid>
      }
      onDelete={onDelete}
      icon={icon}
    />
  );
}

function FilterEditor(props: VisitSearchFieldCriteria) {
  const { label, editor, form, api, field } = props;
  const { numFields } = form;

  const { closeFilter, addFilter, search, deleteFilter } = api.actions;
  const open = api.data((s) => s.openFilter);

  const onCancel = () => {
    closeFilter();
  };

  const onSave = async () => {
    await form.submit();

    const values: any = form.values.getState().value;
    if (
      values &&
      (values.control?.length == 0 ||
        values?.control == '' ||
        (form.numFields == 1 && !values.control))
    ) {
      
      deleteFilter(props);
      search();
      onCancel();
    }else if ((values.start && values.end) || field.startDate) {
      const start = new Date(values.start);
      const end = new Date(values.end);
      if (validDateObject(start) && validDateObject(end)) {
        addFilter(props);
        search();
        onCancel();
      }
    }else if (form.valid.getState().value) {
      addFilter(props);
      search();
      onCancel();
    }
  };
  const name = (field?.fieldName || 'filter') + '-dialog';
  return (
    <Dialog open={open}>
      {label && numFields > 1 && <DialogTitle>{label}</DialogTitle>}
      <DialogContent
        style={{ zIndex: 1501, width: 400, minHeight: 85, overflowY: 'hidden' }}
      >
        <div
        onKeyDown={(e) => {
          if (e.key === 'Enter') {
            e.preventDefault(); // Prevent default behavior if needed
            onSave();
          }
        }}
      >
        {editor({ ...props, ...{ api } })}
      </div>
      </DialogContent>

      <DialogActions>
        <Button
          onClick={onCancel}
          id={name + '-cancel-btn'}
          variant="outlined"
          color="primary"
        >
          Cancel
        </Button>
        <Button
          id={name + '-submit-btn'}
          onClick={onSave}
          color="primary"
          variant="contained"
        >
          {' '}
          Save{' '}
        </Button>
      </DialogActions>
    </Dialog>
  );
}

function FilterList(api: VisitSearchApi) {
  const filters = api.data((s) => s.filters);
  const selected = api.data((s) => s.selectedFilter);

  console.info('filters', filters)

  return (
    <Grid
      item
      container
      direction="row"
      xs={5}
      spacing={1}
      justify="flex-start"
      alignItems="flex-start"
      style={{ width: '100%' }}
    >
      {(filters || []).map((v, i) => (
        <Grid item key={i}>
          <Filter {...v} api={api} />
        </Grid>
      ))}
      {selected && <FilterEditor {...selected} api={api} />}
    </Grid>
  );
}

function Sort(props: VisitSearchFieldCriteria) {
  const { icon, label, field, api } = props;
  const { deleteSort } = api.actions;

  const [toggle, setToggle] = useState(field.sortOrder === 1);

  const onDelete = () => {
    deleteSort(props);
  };

  const onEdit = () => {
    setToggle(!toggle);
    field.sortOrder = !toggle ? -1 : 1;
    api.actions.updateSort(props);
  };

  return (
    <Chip
      size="small"
      color="secondary"
      style={{ backgroundColor: darkBlue }}
      label={
        <Grid
          container
          direction="row"
          spacing={1}
          justify="space-around"
          alignItems="center"
          style={{ flexWrap: 'nowrap' }}
        >
          <Grid
            item
            style={{ paddingLeft: 11, paddingRight: 6, paddingBottom: 5 }}
          >
            <Typography
              style={{
                whiteSpace: 'nowrap',
                fontWeight: 'bold',
                color: 'white',
              }}
              variant="caption"
              color="textSecondary"
            >
              {label}
            </Typography>
          </Grid>

          <Grid item>
            <IconButton
              onClick={onEdit}
              style={{ width: '8px', height: '8px' }}
              id={"edit-sort-" + field?.fieldName?.toLowerCase()?.trim() + "-btn"}
            >
              {field.sortOrder === -1 ? (
                <ArrowDownward fontSize="small" htmlColor="white" />
              ) : (
                <ArrowUpward fontSize="small" htmlColor="white" />
              )}
            </IconButton>
          </Grid>
        </Grid>
      }
      onDelete={onDelete}
      icon={icon}
    />
  );
}

function SortList(api: VisitSearchApi) {
  const sort = api.data((s) => s.sort);
  return (
    <Grid
      item
      container
      direction="row"
      xs={5}
      spacing={1}
      justify="flex-start"
      alignItems="flex-start"
      style={{ width: '100%' }}
    >
      {(sort || []).map((v, i) => (
        <Grid item key={i}>
          <Sort {...v} api={api} />
        </Grid>
      ))}
    </Grid>
  );
}

function FilterSort(props: VisitSearchFieldCriteria) {
  const { icon, label, api, field } = props;
  const { openFilter, addSort, hasFilter, hasSort } = api.actions;

  const onFilter = () => {
    openFilter(props);
  };
  const onSort = () => {
    addSort(props);
  };

  const name = field?.fieldName || 'filter';



 
  return (
    <Chip
      size="small"
      variant="outlined"
      label={
        <Grid
          container
          direction="row"
          spacing={0}
          justify="center"
          alignItems="center"
          style={{ flexWrap: 'nowrap' }}
        >
          <Grid
            item
            style={{ paddingLeft: 6, paddingRight: 6, paddingBottom: 0 }}
          >
            <Typography
              id={name + '-sort'}
              style={{ whiteSpace: 'nowrap', fontWeight: 'bold' }}
              variant="caption"
              color="textSecondary"
            >
              {label}
            </Typography>
          </Grid>

          <Grid item>
            <IconButton
              id={name + '-open-form'}
              disabled={hasFilter(props)}
              onClick={onFilter}
              style={{ width: '8px', height: '8px' }}
            >
              {withTooltip(
                'Filter',
                <MFilter fontSize="small" style={{ paddingTop: 3 }} />
              )}
            </IconButton>
          </Grid>

          <Grid item>
          { field?.sortable != false &&  <IconButton
              id={name + '-sort'}
              disabled={hasSort(props)}
              onClick={onSort}
              style={{ width: '8px', height: '8px' }}
            >
              {withTooltip(
                'Sort',
                <Height fontSize="inherit" style={{ paddingTop: 5 }} />
              )}
            </IconButton>}
          </Grid>
        </Grid>
      }
      icon={icon}
    />
  );
}

function FilterSortList(api: VisitSearchApi) {
  const pageApi = createPageApi();
  api = visitSearchApi(pageApi, false);
  const fields = api.data((s) => s.fields);
  const { search, reset } = api.actions;

  const onRefresh = () => {
    search();
  };

  const onReset = () => {
    reset();
    search();
  };

  return (
    <Grid
      item
      container
      direction="row"
      spacing={1}
      justify="flex-start"
      alignItems="center"
      style={{ width: '100%', height: '100%', paddingBottom: 6 }}
    >
      <Grid item style={{ paddingRight: 0 }}>
        <IconButton
          id="refresh-search-btn"
          onClick={onRefresh}
          style={{ width: '12px', height: '12px' }}
        >
          {withTooltip(
            'Refresh List',
            <Refresh
              color="primary"
              fontSize="large"
              style={{ paddingTop: 4 }}
              id="refresh_icon"
            />
          )}
        </IconButton>
      </Grid>
      <Grid item style={{ paddingRight: 18 }}>
        <IconButton
          id="clear-filters-btn"
          onClick={onReset}
          style={{ width: '12px', height: '12px' }}
        >
          {withTooltip(
            'Clear Fields',
            <HighlightOff
              color="primary"
              fontSize="large"
              style={{ paddingTop: 4 }}
              id="clear_icon"
            />
          )}
        </IconButton>
      </Grid>
      {(fields || []).map((v, i) => (
        <Grid item key={i}>
          <FilterSort {...v} api={api} />
        </Grid>
      ))}
    </Grid>
  );
}

interface VisitSearchProps {
  api: VisitSearchApi;
}
export function VisitSearch(props: VisitSearchProps) {
  const { api } = props;


  return (
    <Grid
      item
      container
      direction="column"
      spacing={1}
      justify="flex-start"
      alignItems="flex-start"
      style={{ width: '100%', paddingBottom: 6, paddingTop: 0, minHeight: 76 }}
    >
      <FilterSortList {...api} />
      <Divider
        orientation="horizontal"
        style={{ width: '100%', height: '1px' }}
        flexItem
      />

      <Grid
        item
        container
        direction="row"
        spacing={1}
        justify="flex-start"
        alignItems="flex-start"
        style={{ width: '100%', paddingTop: 6 }}
      >
        <Grid item>
          <MFilter fontSize="small" htmlColor={orange} />
        </Grid>
        <FilterList {...api} />
        <Grid item>
          <Height fontSize="small" htmlColor={darkBlue} />
        </Grid>
        <SortList {...api} />
      </Grid>
    </Grid>
  );
}


